import React from "react";
import ExpandePublicLayout from "./ExpandePublicLayout";

export default function ExpandeSupportPage() {
  return (
    <ExpandePublicLayout title="Soporte | Expande">
      <section className="expub-section">
        <p className="expub-kicker">Soporte</p>
        <h1>Ayuda para usuarios de Expande</h1>
        <p>
          Si necesitas ayuda con el acceso a tu cuenta, uso de la app, pedidos, clubes o eliminación
          de cuenta, escribe al equipo de soporte. Atendemos solicitudes relacionadas con la app
          Expande Bolivia.
        </p>
        <p className="expub-contact">
          <a href="mailto:soporte@misterquillo.com">soporte@misterquillo.com</a>
        </p>
      </section>

      <section className="expub-grid">
        <article className="expub-card">
          <h2>Cuenta y acceso</h2>
          <p>Ayuda con inicio de sesión por correo, Google, Sign in with Apple y recuperación de acceso.</p>
        </article>
        <article className="expub-card">
          <h2>Clubes y pedidos</h2>
          <p>Soporte sobre información de clubes saludables, productos y operaciones dentro de la app.</p>
        </article>
        <article className="expub-card">
          <h2>Privacidad</h2>
          <p>Consultas sobre datos personales, eliminación de cuenta y gestión de solicitudes de privacidad.</p>
        </article>
      </section>
    </ExpandePublicLayout>
  );
}
